import { Component } from 'preact';
import PropTypes from 'prop-types';

// Components
import InputText from './InputText';

class CvrText extends Component {
  render() {
    const newProps = this.props;
    newProps.type = 'tel';
    // eslint-disable-next-line no-unused-vars
    newProps.updateValue = (value, values) => {
      let newValue = value;
      if (value) {
        const regex = new RegExp('(.*?)(\\d{1,8})?(.*)');
        newValue = value.replace(regex, '$2');
      }
      return newValue;
    };

    return (
      <InputText
        {...newProps}
      />
    );
  }
}

export default CvrText;

CvrText.defaultProps = {
  required: false,
  placeholder: null,
  desc: null,
  label: null,
  maxLength: null,
  endFocus: null,
  mobileColumns: null,
  isLoading: null,
  formValues: [],
  formValuesTemplate: '',
  actions: [],
  disabled: false,
  labelClass: '',
};

CvrText.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  formValues: PropTypes.array,
  formValuesTemplate: PropTypes.string,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  columns: PropTypes.string.isRequired,
  mobileColumns: PropTypes.string,
  label: PropTypes.string,
  desc: PropTypes.string,
  maxLength: PropTypes.number,
  endFocus: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  isLoading: PropTypes.string,
  values: PropTypes.array.isRequired,
  actions: PropTypes.array,
  dispatch: PropTypes.func.isRequired,
  setValues: PropTypes.func.isRequired,
  translations: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  labelClass: PropTypes.string,
};
